import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductType } from '../../../../../models/productType.model';
import { ProductTypeService } from '../../../../../services/productType.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../../services/category.service';
import { Category } from '../../../../../models/category.model';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-update-sub-category',
  templateUrl: './update-sub-category.component.html',
  styleUrls: ['./update-sub-category.component.scss']
})
export class UpdateSubCategoryComponent implements OnInit {
  @ViewChild('closeeditbutton4') closeeditbutton4: ElementRef;

  displayedVariants: any[] = [];
  displayedVariantsTmp: any[] = [];
  search: any;
  allVariant: any[] = [];
  allProductPrivate!: any
  allServicePrivate!: any
  statusSearchText = '';
  searchText = '';
  productTypeId: number;
  subCategoryName = '';
  productType: ProductType

  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems: any;
  categoryAngularList: Category[] = [];
  productTypeAngularList: ProductType[] = [];
  selectedProductTypes: any[] = [];
  selectedCategory: any = [];
  categories: any[] = [];
  dropdownSettingsCategorie = {};
  productTypeName: string
  constructor(private router: Router, private productTypeService: ProductTypeService,
    private route: ActivatedRoute, private location: Location, private categorieService: CategoryService,
  ) { }

  ngOnInit(): void {
    this.productTypeId = Number(this.route.snapshot.paramMap.get('id'));
    console.log(this.subCategoryName);
    this.allVariants();
    this.loadProductType();
    this.loadFilteredProductTypes();
    this.loadAndPersistSubCategoryName();
    this.dropdownSettingsCategorie = {
      singleSelection: true,
      //limitSelection: 1,
      text: "Sélectionnez une sous-catégorie",
      searchPlaceholderText: "Recherchez...",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      textField: 'name',
      idField: 'id',
      labelKey: 'name',
      primaryKey: 'id',
    };

  }

  private loadAndPersistSubCategoryName(): void {
    const storageKey = `subCategoryName_${this.productTypeId}`;
    
    // First, try to get from localStorage
    const savedName = localStorage.getItem(storageKey);
    if (savedName) {
      this.subCategoryName = savedName;
      return;
    }

    // If not in localStorage, try to get from navigation state
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state?.['name']) {
      this.subCategoryName = navigation.extras.state['name'];
      localStorage.setItem(storageKey, this.subCategoryName);
      return;
    }

    // Finally, try to get from history state
    const currentState = history.state;
    if (currentState?.name) {
      this.subCategoryName = currentState.name;
      localStorage.setItem(storageKey, this.subCategoryName);
      return;
    }
  }

  loadFilteredProductTypes() {
    this.productTypeService.getProductType().subscribe({
      next: (data: any) => {
        // Filtre pour exclure la sous-catégorie actuelle
        this.productTypeAngularList = data.filter((type: ProductType) =>
          type.id !== this.productTypeId
        );
        // console.log("Sous-catégories filtrées:", this.productTypeAngularList);
      },
      error: (err) => {
        console.error('Erreur lors du chargement des sous-catégories:', err);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de charger les sous-catégories',
          icon: 'error',
          timer: 4000,
          timerProgressBar: true
        });
      }
    });
  }

  // Mise à jour de la méthode pour la modal
  openChangeModal(variant: any) {
    // Réinitialise la sélection à chaque ouverture
    this.selectedProductTypes = [];

    // Vérifie si la liste des sous-catégories est bien chargée
    if (this.productTypeAngularList.length === 0) {
      this.loadFilteredProductTypes();
    }
  }

  onChangeCategory(variantID: string): void {
    console.log("Début de la fonction onChangeCategory");
    // Vérifie si variantID est valide
    if (!variantID) {
      console.error('Erreur : variantID est vide');
      Swal.fire({
        title: 'Erreur',
        text: 'L\'ID de la variante est vide.',
        icon: 'error',
        timer: 4000,
        timerProgressBar: true
      });
      return;
    }
    // Vérifie si une nouvelle sous-catégorie a été sélectionnée
    if (!this.selectedProductTypes || this.selectedProductTypes.length === 0) {
      console.warn('Aucune sous-catégorie sélectionnée');
      Swal.fire({
        title: 'Erreur',
        text: 'Veuillez sélectionner une nouvelle sous-catégorie.',
        icon: 'warning',
        timer: 4000,
        timerProgressBar: true
      });
      return;
    }
    // Récupère l'ID de la nouvelle sous-catégorie sélectionnée
    const newProductTypeID = this.selectedProductTypes[0]?.id;
    if (!newProductTypeID) {
      console.error("Erreur : L'ID de la nouvelle sous-catégorie est introuvable.");
      Swal.fire({
        title: 'Erreur',
        text: 'ID de la nouvelle sous-catégorie introuvable.',
        icon: 'error',
        timer: 4000,
        timerProgressBar: true
      });
      return;
    }
    console.log(`ID variante: ${variantID}, Nouvelle sous-catégorie: ${newProductTypeID}`);
    // Confirmation de l'utilisateur
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: "Cette action mettra à jour la sous-catégorie.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, continuer',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Mise à jour en cours...");
        this.productTypeService.updateVariant(variantID, newProductTypeID).subscribe({
          next: (response) => {
            console.log('Réponse API:', response);
            Swal.fire({
              title: 'Succès',
              text: 'La sous-catégorie a été mise à jour avec succès !',
              icon: 'success',
              timer: 3000,
              timerProgressBar: true
            });
            // Ferme la modal et rafraîchit les données
            if (this.closeeditbutton4) {
              this.closeeditbutton4.nativeElement.click();
            }
            this.allVariants();
            // Réinitialise la sélection
            this.selectedProductTypes = [];
          },
          error: (error) => {
            console.error('Erreur API:', error);
            Swal.fire({
              title: 'Erreur',
              text: error.error.errorMessage,
              icon: 'error',
              confirmButtonText: 'Réessayer'
            });
          }
        });
      } else {
        console.log("Mise à jour annulée par l'utilisateur.");
        Swal.fire({
          title: 'Annulé',
          text: 'La mise à jour a été annulée.',
          icon: 'info',
          timer: 4000,
          timerProgressBar: true
        });
      }
    });
  }


  onItemSelectCategory(event: any) {
    // Stocke la sélection
    this.selectedProductTypes = [event];
    // console.log('Nouvelle sous-catégorie sélectionnée:', event);
  }

  OnItemDeSelectCategorie(event: any) {
    this.selectedProductTypes = [];
    // console.log('Sous-catégorie désélectionnée');
  }

  // Méthode pour actualiser les données en fonction de la page
  updatePageData() {
    const startIndex = (this.pageNumber - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedVariants = this.allVariant.slice(startIndex, endIndex);
    // console.log(this.displayedVariants);
    this.displayedVariantsTmp = this.displayedVariants
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  searchFilter($event: KeyboardEvent) {
    this.displayedVariants = this.displayedVariantsTmp.filter(
      value => value.variantName?.toLowerCase().includes(this.search) ||
        value.productTypeName?.toLowerCase().includes(this.search) ||
        value.variantID?.toLowerCase().includes(this.search) ||
        value.variantType?.toLowerCase().includes(this.search)

    );
  }

  allVariants() {
    this.searchText = this.search !== undefined ? this.search : '';

    this.productTypeService.getProductTypeVariants(this.productTypeId).subscribe(data => {
      this.productType = data;
      this.productTypeName = this.productType.name
      console.log(" this.productType", this.productTypeName)
      console.log(" this.productType")
      console.log(this.productType)
      if (!this.allProductPrivate) {
        this.allProductPrivate = this.productType.products.map(val => ({
          variantName: val.name,
          variantID: val.productID,
          categoryName: val.category?.name,
          productTypeName: val.category?.productTypes?.name,
          variantType: "product",
        }));
      }

      if (!this.allServicePrivate) {
       console.log(" this.allServicePrivate")
       console.log(this.allServicePrivate)
        this.allServicePrivate = this.productType.services.map(val => ({
          variantName: val.titre,
          variantID: val.serviceID,
          categoryName: val.category?.name,
          productTypeName: val.category?.productTypes?.name,
          variantType: "service",
        }));
      }

      // Fusionner les produits et services dans une seule liste
      this.allVariant = [...this.allProductPrivate, ...this.allServicePrivate];

      // Total des éléments pour la pagination
      this.totalItems = this.allVariant.length;

      // Mise à jour des éléments affichés pour la page actuelle
      this.updatePageData();
    });
  }

  
  loadProductType() {
    this.productTypeService.getIdProductType(this.productTypeId).subscribe(data => {
      let currentProducType: ProductType = data
      this.productTypeName = currentProducType.name
      console.log(" this.productTypeName", this.productTypeName)
     
    });
  }


  ascendingOrderTitle: boolean = true;
  sortByTitle() {
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingOrderTitle) {
        return a.variantName.toLowerCase().localeCompare(b.variantName.toLowerCase());
      } else {
        return b.variantName.toLowerCase().localeCompare(a.variantName.toLowerCase());
      }
    })
    this.ascendingOrderTitle = !this.ascendingOrderTitle;
  }

  ascendingOrderProductType: boolean = true;
  sortByProductType() {
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingOrderProductType) {
        return a.productTypeName.toLowerCase().localeCompare(b.productTypeName.toLowerCase());
      } else {
        return b.productTypeName.toLowerCase().localeCompare(a.productTypeName.toLowerCase());
      }
    })
    this.ascendingOrderProductType = !this.ascendingOrderProductType;
  }

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.updatePageData();
  }

  ascendingType: boolean = true;
  sortByType() {
    //// console.log(this.posts);
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingType) {
        return a.variantType.toLowerCase().localeCompare(b.variantType.toLowerCase());
      } else {
        return b.variantType.toLowerCase().localeCompare(a.variantType.toLowerCase());
      }
    })
    this.ascendingType = !this.ascendingType;
  }

  ascendingOrderCategory: boolean = true;
  sortByCategory() {
    this.displayedVariants.sort((a, b) => {
      if (this.ascendingOrderCategory) {
        return a.categoryName.toLowerCase().localeCompare(b.categoryName.toLowerCase());
      } else {
        return b.categoryName.toLowerCase().localeCompare(a.categoryName.toLowerCase());
      }
    })
    this.ascendingOrderCategory = !this.ascendingOrderCategory;
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    localStorage.removeItem(`subCategoryName_${this.productTypeId}`);
  }
}
